// Copyright 2018 Sorama B.V.

import { HologramSetAnalysisProperties } from "datatypes/SoramaLocalApi";
import { GenericMeasurement, HologramSet } from "datatypes/SoramaWebApi";

export abstract class IHologramProcessingService {
    /**
     * Get holograms for the given measurement
     * @param measurement Measurement to get the measurement data for the holograms from.
     * @param properties Compute properties for the hologram.
     * @param computationProgressCallback Optional progress callback which will receive periodic progress updates.
     */
    abstract getHolograms(
        measurement: GenericMeasurement,
        properties: HologramSetAnalysisProperties,
        computationProgressCallback?: (progress: number) => void
    ): Promise<HologramSet>;
}
